// extracted by mini-css-extract-plugin
export default {"dark":"law_dark__NWTN8","box":"law_box__j8cef"};